import { MoengageInstance } from '@services/moengage-service';
import { Component, Event, EventEmitter, Host, Prop, State, h } from '@stencil/core';
import { If } from '@utils/If';
import { handleRedirectWithDisclaimerLogic } from '@utils/utilities';
import { BOOKING_TYPES, HEADER_LIST_ITEMS } from '../../../utils/moengage-event-keys';
import { MenuItem, NavigationMenu } from '../../shared/types';

@Component({
  tag: 'menu-list',
  styleUrl: 'menu-list.scss',
  shadow: true,
})
export class MenuList {
  @Prop() menuItems: NavigationMenu;
  @Prop() activeMenuItem: string = '';
  @Prop() ssrEnabled: boolean = false;
  @State() activeMenu: any = {};
  @State() submenuIndex: number = null;
  @Event() showRedirectPopup: EventEmitter<any>;

  activeMenuRect?: DOMRect;

  onClickMenuItem = (e, item: any) => {
    e.preventDefault();
    this.handleRedirectWithDisclaimer(item);

  };

  private async moengageEventCall(item: any): Promise<boolean> {
    const { redirectUrl, title, mainMenu } = item;
    const uniqueId = window.crypto.randomUUID();

    const eventname =
      mainMenu === "Shop" || mainMenu === "Instant Vouchers"
        ? HEADER_LIST_ITEMS[mainMenu]
        : HEADER_LIST_ITEMS[title] ?? title.toLowerCase();

    const event_unique_id = title
      ? `${uniqueId}_${eventname}`
      : uniqueId;

    const moengageAttributes = {
      redirection_url: redirectUrl,
      section: "header",
      event_unique_id,
      booking_type: BOOKING_TYPES[title.toLowerCase()] ?? '',
      source: `header_${title.toLowerCase()}`
    };
    const resp = await MoengageInstance.trackEvent(eventname, moengageAttributes);
    console.log(resp, "ME EVE");
    return resp;
  }


  private async handleRedirectWithDisclaimer(item: any) {
    const { redirectUrl, disclaimer_popup, openRedirectUrlInNewTab, mainMenu, title } = item;

    await this.moengageEventCall(item);
    const result = handleRedirectWithDisclaimerLogic({
      redirectUrl,
      disclaimerSlug: disclaimer_popup?.slug,
      openInNewTab: openRedirectUrlInNewTab
    });

    if (result.showPopup) {
      this.showRedirectPopup.emit({ redirectPopupContentType: result.contentType, redirectTargetUrl: result.redirectUrl, disclaimerContent: result.disclaimerContent, openRedirectUrlInNewTab, mainMenu, title });
    }
  }

  showSubmenu(item: any, ev: MouseEvent, idx: number) {
    const target = ev.currentTarget as HTMLElement;
    this.activeMenuRect = target.getBoundingClientRect();
    this.activeMenu = item;
    this.submenuIndex = idx;
  }

  hideSubMenu() {
    this.activeMenu = {};
  }

  onClickSubMenu = (event: CustomEvent) => {
    event.stopPropagation();
    event.preventDefault();
    const submenuItem = event.detail;
    this.handleRedirectWithDisclaimer(submenuItem);
  };

  render() {
    return (
      <Host>
        <div class="relative flex-grow" onMouseLeave={() => this.hideSubMenu()}>
          <div class={`flex flex-grow ${!this.menuItems?.length ? 'py-5' : ''} no-scrollbar overflow-x-scroll min-w-0 text-sm flex-nowrap`}>
            <If condition={!this.menuItems?.length}
              children={<span>&nbsp;</span>}
            />
            {this.menuItems?.map((item: MenuItem, idx: number) => {
              const isValidMenuItem = !!item.redirectUrl || (Array.isArray(item.header_links) && item.header_links.length > 0);
              const isDisabled = !isValidMenuItem;
              return (
                <a
                  key={item.id}
                  href={isDisabled ? undefined : item.redirectUrl ?? '#'}
                  onMouseEnter={isDisabled ? undefined : (event: MouseEvent) => this.showSubmenu(item, event, idx)}
                  class={`text-gray-300 ${this.ssrEnabled ? '' : 'animate-in'}  select-none px-3 py-5 flex ${idx === 0 ? 'ps-5' : ''} flex-col justify-center relative cursor-pointer ${isDisabled ? 'opacity-50 cursor-not-allowed pointer-events-none' : ''
                    }`}
                  onClick={e => {
                    if (isDisabled || (item.header_links && item.header_links.length > 0)) {
                      e.preventDefault();
                      return;
                    }
                    this.onClickMenuItem(e, item);
                  }}
                  aria-disabled={isDisabled ? 'true' : 'false'}
                >
                  <div class="flex gap-2 flex-nowrap items-center">
                    <div class="text-nowrap">{item.title}</div>
                    <If condition={!!item.badge} children={<header-badge class={'leading-none'} blink={item.badge?.blink}>{item.badge?.title}</header-badge>} />
                  </div>

                  <div class="flex justify-center">
                    <If
                      condition={this.activeMenu.documentId === item.documentId}
                      children={
                        <div class="flex absolute justify-center">
                          <If condition={item?.header_links?.length == 0} children={<div class="gradient-bar" />} />
                          <If condition={item?.header_links?.length > 0} children={<div class="curved-triangle" />} />
                          <If condition={this.activeMenu.documentId === item.documentId && this.activeMenu?.header_links?.length > 0} children={<div class="glow"></div>} />
                        </div>
                      }
                    />
                    <If
                      condition={!this.activeMenu.documentId && this.activeMenuItem === item.key}
                      children={
                        <div class="flex absolute justify-center">
                          <div class="gradient-bar" />
                        </div>
                      }
                    />
                  </div>
                </a>
              );
            })}
          </div>
          <If
            condition={!!this.activeMenu.documentId && this.activeMenu?.header_links?.length > 0}
            children={
              <sub-menu-list
                onSubmenuClick={this.onClickSubMenu}
                menuList={this.menuItems}
                submenuIndex={this.submenuIndex}
                parentRect={this.activeMenuRect}
                class={{
                  'fade-in': !!this.activeMenu.documentId,
                  'fade-out': !this.activeMenu.documentId
                }}
              />
            }
          />
        </div>
      </Host>
    );
  }
}
